/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SignatoryViewModel } from './SignatoryViewModel';
import {
    SignatoryViewModelFromJSON,
    SignatoryViewModelFromJSONTyped,
    SignatoryViewModelToJSON,
} from './SignatoryViewModel';

/**
 * 
 * @export
 * @interface UpsertSignatoryOrchestration
 */
export interface UpsertSignatoryOrchestration {
    /**
     * 
     * @type {number}
     * @memberof UpsertSignatoryOrchestration
     */
    proposalId: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertSignatoryOrchestration
     */
    productId?: number;
    /**
     * 
     * @type {number}
     * @memberof UpsertSignatoryOrchestration
     */
    documentId?: number;
    /**
     * 
     * @type {SignatoryViewModel}
     * @memberof UpsertSignatoryOrchestration
     */
    signatory: SignatoryViewModel;
}

/**
 * Check if a given object implements the UpsertSignatoryOrchestration interface.
 */
export function instanceOfUpsertSignatoryOrchestration(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "signatory" in value;

    return isInstance;
}

export function UpsertSignatoryOrchestrationFromJSON(json: any): UpsertSignatoryOrchestration {
    return UpsertSignatoryOrchestrationFromJSONTyped(json, false);
}

export function UpsertSignatoryOrchestrationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertSignatoryOrchestration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['ProposalId'],
        'productId': !exists(json, 'ProductId') ? undefined : json['ProductId'],
        'documentId': !exists(json, 'DocumentId') ? undefined : json['DocumentId'],
        'signatory': SignatoryViewModelFromJSON(json['Signatory']),
    };
}

export function UpsertSignatoryOrchestrationToJSON(value?: UpsertSignatoryOrchestration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'ProductId': value.productId,
        'DocumentId': value.documentId,
        'Signatory': SignatoryViewModelToJSON(value.signatory),
    };
}

